export const isDivisibleBy = (value, divisor) => !!value && (value % divisor === 0);
